import { render, staticRenderFns } from "./PreProjectLandingPage.vue?vue&type=template&id=8a30a1fe&scoped=true&"
import script from "./PreProjectLandingPage.vue?vue&type=script&lang=js&"
export * from "./PreProjectLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./PreProjectLandingPage.vue?vue&type=style&index=0&id=8a30a1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a30a1fe",
  null
  
)

export default component.exports